import * as React from "react";
const SvgMultiSet = ({ title, titleId, ...props }) => (
  <svg
    width="1em"
    height="1em"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      d="M8.001 12.75a.75.75 0 0 1 .75-.75h1.25V9.75a.75.75 0 0 1 .75-.75h4.5a.75.75 0 0 1 .75.75v6.5a.75.75 0 0 1-.75.75h-2.25v1.25a.75.75 0 0 1-.75.75h-3.5a.75.75 0 0 1-.75-.75v-5.5Zm5 2.75h1.5v-5h-3V12h.75a.75.75 0 0 1 .75.75v2.75Zm-3.5-2v4h2v-4h-2Z"
      fill="currentColor"
    />
    <path
      d="M5.501 2a2.5 2.5 0 0 0-.5 4.95v7.915c0 .77-.21 1.526-.606 2.187l-2.288 3.812A.75.75 0 0 0 2.75 22h18.5a.75.75 0 0 0 .643-1.136l-2.287-3.812a4.25 4.25 0 0 1-.605-2.186V6.95A2.5 2.5 0 0 0 18.5 2h-13Zm12 5v7.866a5.75 5.75 0 0 0 .819 2.957l1.605 2.677H4.075l1.606-2.676a5.75 5.75 0 0 0 .82-2.96V7h11Zm1-1.5h-13a1 1 0 1 1 0-2h13a1 1 0 1 1 0 2Z"
      fill="currentColor"
    />
  </svg>
);
export default SvgMultiSet;
